import * as math from 'mathjs';

class SCARARTrafo {
  /**
   * Analytische inverse Kinematik für den SCARA (Port von SCARA_RTRAFO.m, W. Weber)
   *
   * @param {Matrix} F_akt - aktuelles Zielframe (3x4 oder 4x4)
   * @param {Array|Matrix} q_alt - zeitlich vorhergehender Lösungsvektor (hier ungenutzt, wie im MATLAB-Original)
   * @param {Object} r - Roboterbeschreibung
   * @returns {Matrix|Array} qz - 4x2 Matrix mit den 2 Lösungsvektoren, oder [] falls ausserhalb des Arbeitsbereichs
   */
  run(F_akt, q_alt, r) {
    let F = math.squeeze(F_akt);
    let F_arr = F.toArray ? F.toArray() : F;

    // p_04 = F_akt(:,4) -> Ortsvektor zum TCP in K0
    let p_04 = [F_arr[0][3], F_arr[1][3], F_arr[2][3]];

    // ltcp = A40(:,1), zur Sicherheit auf Einheitsvektor genormt
    let ltcp = [F_arr[0][0], F_arr[1][0], F_arr[2][0]];
    let ltcp_norm = math.norm(ltcp);
    if (ltcp_norm > 1e-10) {
      ltcp = ltcp.map(v => v / ltcp_norm);
    }

    let a = r.joints.map(j => j.a);
    let l1 = a[0]; // Länge Armteil 1
    let l2 = a[1]; // Länge Armteil 2

    let qz;

    let betr2_p = p_04[0] * p_04[0] + p_04[1] * p_04[1];

    // AR_test_aussen: TCP innerhalb Radius l1+l2?
    let AR_test_aussen = Math.pow(l1 + l2, 2) - betr2_p;
    // AR_test_innen: nur relevant falls l2 < l1
    let AR_test_innen = (l2 < l1) ? (betr2_p - Math.pow(l1 - l2, 2)) : 25;

    if (AR_test_aussen >= 0 && AR_test_innen >= 0) {
      // hier nicht alpha wie im Studienheft, wegen Konflikt mit D-H-Parameter alpha, sondern phia
      let A_Euler = Math.atan2(ltcp[1], ltcp[0]);

      let phia = Math.atan2(p_04[1], p_04[0]);
      let beta_1 = Math.acos((l1 * l1 - l2 * l2 + betr2_p) / (2 * l1 * Math.sqrt(betr2_p)));
      let beta_2 = -beta_1;
      let gamma_1 = Math.acos((l1 * l1 + l2 * l2 - betr2_p) / (2 * l1 * l2));
      let gamma_2 = -gamma_1;

      let q1a = phia - beta_1;
      let q1b = phia - beta_2;
      let q2a = Math.PI - gamma_1;
      let q2b = Math.PI - gamma_2;
      let q3 = p_04[2];
      let q4a = A_Euler - q1a - q2a;
      let q4b = A_Euler - q1b - q2b;

      qz = math.matrix([
        [q1a, q1b],
        [q2a, q2b],
        [q3, q3],
        [q4a, q4b]
      ]);
    } else {
      // TCP ausserhalb des AR ohne Berücksichtigung der Gelenkbeschränkungen
      qz = [];
    }

    return qz;
  }
}

export default SCARARTrafo;
